import React from 'react';
import { IconProps } from '../IconProps';
const SvgUsersChat = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M24 23a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM8 23a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm22.895 6.784l-2.226.564a19 19 0 01-9.338 0l-2.226-.564a7.002 7.002 0 0113.79 0zm-16.105 0l-2.226.564a19 19 0 01-9.338 0L1 29.784a7.002 7.002 0 0113.79 0z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.5A2.5 2.5 0 0114.5 2h10A2.5 2.5 0 0127 4.5v5.8a2.5 2.5 0 01-2.5 2.5h-7.943L12 15.884V4.5z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgUsersChat;
